var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"social-button",on:{"click":_vm.onClick}},[_c('img',{attrs:{"src":_vm.imageSrc,"alt":"icon"}}),(_vm.buttonText)?_c('span',{staticClass:"btn-txt"},[_vm._v(_vm._s(_vm.buttonText))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }